import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem, pxToRem, dividerClassName } from '@archipro-design/aria';
export const Wrap: StyleRule = ({ theme }) => ({
    width: '100%',
    borderBottom: `1px solid rgba(52, 52, 52, 0.2)`,
    marginBottom: pxToRem(52),
    [theme.screen.laptop]: {
        padding: pxArrayToRem([0, 0, 32]),
        marginBottom: theme.siteVariables.spaces['space-40'],
        borderBottom: 'none',
    },
    [theme.screen.clamped]: {
        padding: pxArrayToRem([80, 0, 32]),
        margin: pxArrayToRem([0, -14]),
    },
});
export const SectionDivider: StyleRule = () => ({
    [`&.${dividerClassName}`]: {
        padding: 0,
    },
});
export const TileGrid: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        margin: pxArrayToRem([0, -14]),
    },
});
export const TitleWrap: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([0, 18]),
    [theme.screen.laptop]: {
        padding: 0,
        marginLeft: pxToRem(720),
        marginBottom: pxToRem(26),
    },
});
export const TileSlide: StyleRule = () => ({
    width: '100%',
    borderBottom: `1px solid rgba(52, 52, 52, 0.2)`,
    '&:last-child': {
        borderBottom: 'none',
    },
});
export const TileSlideWrap: StyleRule = () => ({
    width: '100%',
});
